import './configs/sentry';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import './index.css';
import { AppStateContextProvider } from './store';
import { App } from './App';
import { registerServiceWorker } from './utils/functions/serviceWorker';
import { platform } from './platform';

// Packaged apps load a local index.html (file://, app://, the Android asset origin), so routing
// stays in memory there; the hosted player keeps real URLs (/reset, /info).
const Router = platform.isPackaged ? MemoryRouter : BrowserRouter;

createRoot(document.getElementById('root')).render(
  <Router>
    <AppStateContextProvider>
      <App />
    </AppStateContextProvider>
  </Router>,
);

// Keep the screen on and register remote keys (platform-specific).
platform.init();

// Hosted player: offline boot + cached media playback (production only). Packaged apps ship
// their files and keep media on the device instead.
if (!platform.isPackaged) registerServiceWorker();
